<template>
  <div
    v-if="user.avatar"
    class="rounded-circle d-flex "
    :style="`${sizeComputed}`"
  >
    <img :src="avatarUrl" alt="" class="img-fluid rounded-circle">
  </div>
  <div
    v-else
    class="rounded-circle d-flex justify-content-center align-items-center"
    :style="`${sizeComputed} background-color:${strToColor};`"
  >
    <div class="text-white">
      {{ initial }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: ['user', 'size'],
  computed: {
    avatarUrl() {
      return `https://djceg34j53tq.cloudfront.net/${this.user.avatar}`;
    },
    sizeComputed() {
      if (this.size) {
        return `height:${this.size}px; width:${this.size}px;`
      }
      return `height:40px; width:40px;`
    },
    initial() {
      return _.get(this, 'user.name[0]', 0)
    },
    strToColor() {
      let str = `${this.user.id}${this.user.name}`
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
      }
      let colour = '#'
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xff
        colour += ('00' + value.toString(16)).substr(-2)
      }
      return colour
    },
  },
}
</script>

<style></style>
